import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {lastValueFrom, Observable} from 'rxjs';
import { environment } from '../../environments/environment';
import { ClampDefinition } from '../models/clamp-definition.model';
import { Register } from '../models/hub.model';

@Injectable({
  providedIn: 'root'
})
export class InstallationApiService {
  private apiUrl = environment.installationApiUrl;

  constructor(private http: HttpClient) {}

  /**
   * Get hub configuration details
   * @param hubId The ID of the hub
   * @returns An Observable with the hub configuration details
   */
  getHubConfiguration(hubId: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/hub/${hubId}`);
  }

  /**
   * Get all clamp definitions
   * @returns An Observable with all clamp definitions
   */
  getClampDefinitions(): Observable<ClampDefinition[]> {
    return this.http.get<ClampDefinition[]>(`${this.apiUrl}/clamp_definitions`);
  }

  /**
   * Check if a location exists
   * @param locationLabel The label of the location to check
   * @returns An Observable with the existence status of the location
   */

  /**
   * Update a register
   * @param hubId The ID of the hub
   * @param registerIndex The index of the register in the registers array
   * @param body
   * @returns An Observable with the updated hub configuration
   */
  async updateRegister(hubId: string, registerIndex: number, body: any) {


    try {

      const response = await lastValueFrom(this.http.patch(`${this.apiUrl}/hub/${encodeURIComponent(hubId)}/${encodeURIComponent(registerIndex)}`, body));

      if (response) {
        return response;
      } else {
        return null;
      }

    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }

  }
}
